import LightningContactChargingCenters from "../classes/LightningContactChargingCenter"

export const lightningContactChargingCenters = [
  new LightningContactChargingCenters({alias:"medidor", svgSrc: "/symbol-assets/Medidor.svg", label: "Medidor"}),
];
